export default __webpack_public_path__ + "static/media/img10.55bc52d6.JPG";